<template>
  <div class="body">
    <img class="bgimg" src="/static/images/1531/yz.png">
    <div class="user-box">
      <div class="head">
        <img :src="userData.avatarUrl">
      </div>
      <div class="right-box">
        <div class="name">{{userData.clerkName}}</div>
        <div class="member">
          <div>
            <span v-if="userData.isMember">{{formatDate(userData.memberExpireTime)}}会员到期</span>
            <span v-if="userData.isRecommend" :style="userData.isMember ? 'margin-left: 10px' : '' ">{{formatDate(userData.recommendExpireTime)}}推荐位到期</span>
          </div>
          <div v-if="!userData.hasCourse && !userData.isMember && !userData.isRecommend">您当前未开通任何套餐</div>
        </div>
      </div>
    </div>
    <div class="option-box">
      <div v-for="(item,index) of titleList" :key="index" @click="optionClick(item.id)" class="option">
        <span :class="item.id == id ? 'click' : ''">{{item.name}}</span>
        <div v-if="item.id == id" class="l"></div>
      </div>
    </div>
    <div class="content-box">
      <div class="equity">
        <div v-for="(item,index) of titleList" :key="index">
          <div v-if="item.id == id">
            <div class="title">{{item.name}}专属权益</div>
            <div v-html="item.content"></div>
          </div>
        </div>
      </div>
      <div class="recommend" v-if="recommendCount">
        <div class="title"><span class="left-box">推荐位剩余：</span><span class="right-box">{{recommendCount}}位</span></div>
        <div v-if="lastExpireTime" class="time">
          <div class="timeTitle">距可购买时间还剩</div>
          <div class="time-box">{{formatDate(lastExpireTime,'DD天HH小时mm分')}}</div>
        </div>
      </div>
      <div v-else-if="recommendCount == 0 && titleType == 'recommend'" class="recommend">
        <div class="title"><span class="left-box">推荐位已满</span></div>
      </div>
      <div class="package">
        <div v-for="(item,index) of titleList" :key="index">
          <div class="title" v-if="item.id == id">{{item.name}}套餐</div>
        </div>
        <div class="package-option">
          <div v-for="(item,index) of dataList" :key="index" @click="packageClick(item.id,item.name,item.synopsis,item.nonPrice,item.price)" class="package-box" :class="item.id == packageId ? 'packageClick' : ''">
            <div class="name-box">
              <div class="name">{{titleType != 'course' ? item.dayNum + '天卡' : item.name}}</div>
            </div>
            <div style="padding-bottom: 13px">
              <div class="price-box">
                <div class="unit">￥</div>
                <div v-if="titleType == 'member'" class="price">{{formatPrice(item.price)}}</div>
                <div v-else class="price">{{userData.isMember ? formatPrice(item.price) : formatPrice(item.nonPrice)}}</div>
              </div>
              <div v-if="titleType != 'member'" class="member-price">
                <div :class="userData.isMember ? '' : 'member-style'" class="member-price-box">{{userData.isMember ? '非' : ''}}会员价￥{{userData.isMember ? formatPrice(item.nonPrice) : formatPrice(item.price)}}</div>
              </div>
              <div v-if="userData.isMember && titleType != 'member'" class="member-sx">已享会员价</div>
            </div>
          </div>
        </div>
      </div>
      <div v-for="(item,index) of titleList" :key="index">
        <div v-if="item.id == id && item.serviceAgreement" class="illustrate">
          <van-radio-group v-model="agreement" direction="horizontal">
            <van-radio name="1">
              <span class="title">购买说明：</span>
              <span class="q">购买即表示同意</span>
              <span class="fwxy" @click.stop="fwxyClick(item.serviceAgreement)">《{{item.name}}服务协议》</span>
            </van-radio>
          </van-radio-group>

        </div>
      </div>
      <div v-if="this.courseName" class="course-box">
        <div class="title">课程名字</div>
        <div class="course">{{this.courseName}}</div>
      </div>
      <div v-if="this.courseSynopsis" class="course-box">
        <div class="title">课程简介</div>
        <div v-html="this.courseSynopsis"></div>
      </div>
    </div>
    <div class="botton-box">
      <div class="p">
        <div class="text1">合计：</div>
        <div class="text2">￥</div>
        <div v-if="titleType == 'member'" class="text3">{{formatPrice(price)}}</div>
        <div v-else class="text3">{{userData.isMember ? formatPrice(price) : formatPrice(nonPrice)}}</div>
      </div>
      <div v-if="recommendCount == 0 && !userData.isRecommend" class="botton bStyle">
        <span>名额已满</span>
      </div>
      <div v-else class="botton" @click="titleType == 'member' ? buy() : onOrder()">
        <span>立即购买</span>
      </div>
    </div>

    <van-dialog v-model="wechatShow" title="提交信息" show-cancel-button confirmButtonText="支付" :before-close="wechatConfirm">
      <div>
        <van-field v-model="wechat"
                   required
                   label="你的微信号"
                   placeholder="wxid开头的搜不到哦"
                   :rules="[{ required: true, message: '请输入微信号' }]"
        />
        <div style="display: table;margin: 0 auto;color: #999;margin-top: 5px">
          <img class="wave" src="/static/images/warning.png" width="14" style="margin: 3px 2px 0 1px">
          <span style="vertical-align: top;font-size:14px;">'请确保微信输入正确，并关闭微信隐私保护设置~</span>
        </div>
      </div>
    </van-dialog>

  </div>
</template>

<script>
import Vue from 'vue';
import {Cell, CellGroup, Col, Dialog, Icon, Row, Switch, Toast, RadioGroup, Radio} from 'vant';
import {clerkDetail,titleList,detailList,fwOrder} from "@/api/fwshop";
import moment from "moment";
import Decimal from "decimal.js";
import {wx, wxConfig} from '@/libs/jssdk-util'


Vue.use(Row)
    .use(Col)
    .use(Icon)
    .use(CellGroup)
    .use(Cell)
    .use(Switch)
    .use(Dialog)
    .use(Toast)
    .use(RadioGroup)
    .use(Radio)

export default {
  name: 'fwshop',
  components: {

  },
  data() {
    return {
      titleType:null,
      userData: null,
      titleList: null,
      agreement: '',
      id: null,
      dataList: null,
      packageId: null,
      courseName: null,
      courseSynopsis: null,
      recommendCount: null,
      lastExpireTime: null,
      nonPrice: 0,
      price: 0,
      queryType: 1,
      wechat: null,
      wechatShow: false,
    }
  },
  methods: {
    buy(){
      if(this.packageId == null){
        return Toast('请选择套餐')
      }
      if (this.titleList != null && this.titleList.length > 0) {
        for (let item of this.titleList) {
          if (item.id == this.id && item.serviceAgreement && this.agreement != 1) {
            return Toast('未同意协议');
          }
        }
      }
      let price = null
      let type = null
      if(this.titleType == 'member'){
        price = this.price
        if(this.price == 0){
          type = 'free'
        }else {
          type = 'weixin'
        }
      }else {
        if(this.userData.isMember){
          price = this.price
          if(this.price == 0){
            type = 'free'
          }else {
            type = 'weixin'
          }
        }else {
          price = this.nonPrice
          if(this.nonPrice == 0){
            type = 'free'
          }else {
            type = 'weixin'
          }
        }
      }
      Toast.loading({
        mask: true,
        message: '请稍候...'
      })
      fwOrder(
          this.packageId,
          type,
          price,
          ''
      ).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          const handleOrder = data.handleOrder
          if (handleOrder) {
            Dialog.alert({
              title: '提示',
              message: '支付成功'
            }).then(() => {
              this.user()
              this.optionClick(this.id)
            })
          } else {
            const payData = data.payData;
            // 发起微信支付请求
            wx.chooseWXPay({
              timestamp: payData.timeStamp,
              nonceStr: payData.nonceStr,
              package: payData.packageValue,
              signType: payData.signType,
              paySign: payData.paySign,
              success() {
                Dialog.alert({
                  title: '支付成功',
                  confirmButtonColor: 'var(--primary-color)',
                  beforeClose: (action, done) => {
                    this.user()
                    this.optionClick(this.id)
                    done()
                  }
                })
              },
              fail (err) {
                Toast(err.errMsg ? err.errMsg : '支付失败')
              }
            })
          }
        } else {
          Dialog.alert({
            title: '创建订单失败',
            message: data.msg
          })
        }
      })
    },
    wechatConfirm(action, done) {
      if (action == 'confirm') {
        if (this.wechat == null || this.wechat == '') {
          Toast.fail("请输入微信号")
          done(false)
          return
        }
        if(this.packageId == null){
          Toast.fail('请选择套餐')
          done(false)
          return
        }
        // 弹出框
        Toast.clear(true)
        let price = null
        let type = null
        if(this.userData.isMember){
          price = this.price
          if(this.price == 0){
            type = 'free'
          }else {
            type = 'weixin'
          }
        }else {
          price = this.nonPrice
          if(this.nonPrice == 0){
            type = 'free'
          }else {
            type = 'weixin'
          }
        }
        Toast.loading({
          mask: true,
          message: '请稍候...'
        })
        fwOrder(
            this.packageId,
            type,
            price,
            this.wechat
        ).then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            // 关闭上拉菜单
            this.wechatShow = false
            const handleOrder = data.handleOrder
            if (handleOrder) {
              Dialog.alert({
                title: '提示',
                message: '支付成功'
              }).then(() => {
                this.user()
                this.optionClick(this.id)
              })
              done()
            } else {
              const payData = data.payData;
              // 发起微信支付请求
              wx.chooseWXPay({
                timestamp: payData.timeStamp,
                nonceStr: payData.nonceStr,
                package: payData.packageValue,
                signType: payData.signType,
                paySign: payData.paySign,
                success() {
                  Dialog.alert({
                    title: '支付成功',
                    confirmButtonColor: 'var(--primary-color)',
                    beforeClose: (action, done) => {
                      done()
                      this.user()
                      this.optionClick(this.id)
                    }
                  })
                },
                fail (err) {
                  Toast(err.errMsg ? err.errMsg : '支付失败')
                }
              })
              done()
            }
          } else {
            Dialog.alert({
              title: '创建订单失败',
              message: data.msg
            })
          }
        })
      }else {
        done()
        return
      }
    },
    onOrder() {
      if(this.packageId == null){
        return Toast('请选择套餐')
      }
      if (this.titleList != null && this.titleList.length > 0) {
        for (let item of this.titleList) {
          if (item.id == this.id && item.serviceAgreement && this.agreement != 1) {
            return Toast('未同意协议');
          }
        }
      }
      this.wechat = null
      this.wechatShow = true
    },
    user() {
      clerkDetail().then(res => {
        const data = res.data;
        if (data.code == 0) {
          this.userData = data.clerkQuity
        }
      })
    },
    title(){
      titleList().then(res => {
        const data = res.data;
        if (data.code == 0) {
          this.titleList = data.list
          let type = this.queryType != null && this.queryType ? this.queryType : 1
          this.titleList.forEach(item => {
            if (type == item.type) {
              this.id = item.id
              this.optionClick(item.id)
            }
          })
        }
      })
    },
    fwxyClick(serviceAgreement){
      Dialog.alert({
        message: serviceAgreement,
      }).then(() => {});
    },
    packageClick(id,courseName,courseSynopsis,nonPrice,price){
      this.packageId = id
      this.courseName = courseName
      this.courseSynopsis = courseSynopsis
      this.nonPrice = nonPrice
      this.price = price
    },
    optionClick(id){
      if (this.id != id) {
        this.agreement = ''
      }
      this.id = id
      this.packageId = null
      this.courseName = null
      this.courseSynopsis = null
      this.nonPrice = 0
      this.price = 0
      detailList(this.id).then(res => {
        const data = res.data;
        if (data.code == 0) {
          this.dataList = data.list
          this.titleType = data.titleType
          this.recommendCount = data.recommendCount
          this.lastExpireTime = data.lastExpireTime
        }
      })
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    },
  },
  mounted() {
    this.queryType = this.$route.query.type
    this.user()
    this.title()
    wxConfig(['chooseWXPay', 'updateAppMessageShareData', 'updateTimelineShareData'],
        () => {
          // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
          wx.updateAppMessageShareData({
            title: `【${this.$store.state.shop.name}】`,
            desc: '会员商城',
            link: window.location.href,
            imgUrl: this.$store.state.shop.logoUrl || '',
            success: function () {
              // Toast('设置成功')
            },
            fail: function (err) {
              // alert(JSON.stringify(err))
            }
          })

          // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
          wx.updateTimelineShareData({
            title: `【${this.$store.state.shop.name}】`,
            link: window.location.href,
            imgUrl: this.$store.state.shop.logoUrl || '',
            success: function () {
              // Toast('设置成功')
            },
            fail: function (err) {
              // alert(JSON.stringify(err))
            }
          })
        })
  }
}
</script>

<style lang="less" scoped>
.body{
  background: #FEF8EC;
  position: relative;
  display: flex;
  flex-flow: column;
  height: 100%;

  .bgimg{
    position: absolute;
    top: 4px;
    right: 0;
    height: 126px;
    z-index: 0;
  }
  .user-box{
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    padding-top: 25px;
    padding-left: 21px;
    .head{
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
      img{
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .right-box{
      margin-left: 9px;
      .name{
        font-size: 14px;
        color: #6A542F;
        font-weight: 500;
      }
      .member{
        font-size: 11px;
        color: #91826B;
        font-weight: 500;
        margin-top: 5px;
      }
    }
  }
  .option-box{
    width: 100%;
    padding-top: 29px;
    padding-bottom: 12px;
    overflow-x: auto;
    display: flex;
    align-items: center;
    .option{
      position: relative;
      font-size: 17px;
      margin: 0 33px;
      span{
        color: #91826B;
        font-weight: 500;
        position: relative;
        z-index: 3;
        white-space: nowrap;
      }
      .click{
        color: #6A542F;
        font-weight: bold;
      }
      .l{
        width: 100%;
        background: #FFE7C5;
        height: 5px;
        border-radius: 5px;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 2;
      }
    }
  }
  .content-box{
    flex: 1;
    height: 0;
    padding-bottom: 100px;
    background: #fff;
    border-radius: 24px 24px 0 0;
    overflow-y: auto;

    .equity{
      padding: 28px 20px 0 20px;
      .title{
        font-size: 15px;
        color: #333333;
        font-weight: bold;
        padding-bottom: 22px;
      }
    }
    .recommend{
      padding: 28px 20px 0 20px;
      .title{
        display: flex;
        align-items: center;
        .left-box{
          font-size: 15px;
          color: #333333;
        }
        .right-box{
          color: #6A542F;
          font-size: 16px;
        }
      }
      .time{
        padding-top: 17px;
        display: flex;
        align-items: center;
        .timeTitle{
          color: #6A542F;
          font-size: 13px;
          margin-right: 5px;
        }
        .time-box{
          padding: 2px 5px;
          border-radius: 3px;
          background: #FFE7C5;
          color: #6A542F;
          font-size: 13px;
        }

      }
    }
    .package{
      padding: 37px 0 0 0;
      width: 100%;
      .title{
        font-size: 15px;
        color: #333333;
        font-weight: bold;
        padding: 0 20px 22px 20px;
      }
      .package-option{
        width: calc(100% - 23px - 8px);
        height: 120px;
        display: -webkit-box;
        overflow-x: auto;
        padding: 0 23px 0 8px;
        white-space: nowrap;
        .package-box {
          width: 99px;
          height: 116px;
          border-radius: 7px;
          background: #FAF9F7;
          margin-left: 15px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          flex-flow: column;
          padding-top: 20px;
          position: relative;
          overflow: hidden;

          .name-box {
            flex: 1;
            width: 100%;
            font-size: 15px;
            color: #221504;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;

            .name {
              text-align: center;
              white-space: pre-line;
              overflow:hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              line-height: 15px;
            }
          }
          .price-box {
            display: flex;
            align-items: end;
            justify-content: center;
            color: #221504;
            font-weight: 800;
            padding-bottom: 5px;

            .unit {
              font-size: 13px;
            }
            .price {
              font-size: 28px;
              line-height: 28px;
            }
          }
          .member-price {
            display: flex;
            justify-content: center;

            .member-price-box {
              padding: 3px 8px;
              border-radius: 3px;
              font-size: 10px;
              color: #221504;
              font-weight: 500;
              white-space: nowrap;
            }
            .member-style {
              background: #FFE7C5;
            }
          }
          .member-sx {
            position: absolute;
            top: 0;
            left: 0;
            border-radius: 0 0 7px 0;
            background: #FFE7C5;
            padding: 2px 5px;
            color: #6A542F;
            font-size: 10px;
            font-weight: 500;
          }
        }
        .packageClick{
          background: #FEFAEF;
          border: 2px solid #EDD5B5;
        }
      }
    }
    .illustrate{
      padding: 28px 20px 0 20px;
      display: flex;
      align-items: center;
      .title{
        font-size: 14px;
        font-weight: bold;
        color: #333333;
      }
      .q{
        font-size: 14px;
        font-weight: 500;
        color: #333333;
      }
      .fwxy{
        color: #19AEFB;
        font-weight: 500;
        font-size: 14px;
      }
    }
    .course-box{
      padding: 28px 20px 0 20px;
      .title{
        font-size: 15px;
        color: #333333;
        font-weight: bold;
        padding-bottom: 22px;
      }
    }
  }
  .botton-box{
    position: fixed;
    left: 0;
    bottom: 0;
    width: calc(100% - 20px * 2);
    background: #FFFFFF;
    box-shadow: 0px 0px 24px 0px rgba(0,0,0,0.09);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 7px 20px;
    z-index: 22;
    .p{
      display: flex;
      align-items: end;
      .text1{
        font-size: 14px;
        font-weight: 500;
        color: #333333;
      }
      .text2{
        font-size: 13px;
        font-weight: 500;
        color: #221504;
      }
      .text3{
        font-size: 20px;
        font-weight: bold;
        line-height: 20px;
        color: #221504;
      }
    }
    .botton{
      width: 142px;
      height: 45px;
      border-radius: 999px;
      font-size: 15px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #2B1601;
      color: #DBC7AF;
    }
    .bStyle{
      background: #F5F4F2;
      color: #999999;
    }
  }
}
</style>
